module.exports = (function() {
    return {
        code(fn) {
            try {
                return fn();
            } catch (err) {
                const stack = err.stack;
                const groupNamespace = '[safe.code]: ' + err.name;

                if (console.group) {
                    console.group(groupNamespace);
                }

                if (console.warn) {
                    console.warn(stack);
                } else {
                    console.log(stack);
                }

                if (console.groupEnd) {
                    console.groupEnd(groupNamespace);
                }

                return false;
            }
        }
    };
}());



// WEBPACK FOOTER //
// ./src/util/safe.js